import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "block text-blue-300" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "block" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueTabPanel = _resolveComponent("PrimeVueTabPanel")!
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_PrimeVueTabView = _resolveComponent("PrimeVueTabView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[33] || (_cache[33] = _createElementVNode("h1", null, "API", -1)),
    _cache[34] || (_cache[34] = _createElementVNode("div", null, "Your API token:", -1)),
    _createElementVNode("code", _hoisted_2, _toDisplayString(_ctx.user.api_token), 1),
    _createVNode(_component_PrimeVueTabView, { class: "mt-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_PrimeVueTabPanel, { header: "Direct publishers API" }, {
          default: _withCtx(() => [
            _cache[10] || (_cache[10] = _createElementVNode("h4", null, "Statistics", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statisticsDirectPublisher, (statistic, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("h5", null, _toDisplayString(statistic.title), 1),
                _createElementVNode("code", _hoisted_3, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/publisher/direct/" + _toDisplayString(statistic.method), 1),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mt-2 font-bold" }, "Available params:", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                  _createTextVNode("api_token"),
                  _createElementVNode("span", { class: "ml-2 text-pink-300" }, "Required")
                ], -1)),
                _cache[4] || (_cache[4] = _createElementVNode("div", null, [
                  _createTextVNode("date_from"),
                  _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
                ], -1)),
                _cache[5] || (_cache[5] = _createElementVNode("div", null, [
                  _createTextVNode("date_to"),
                  _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
                ], -1)),
                _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                  _createTextVNode("date"),
                  _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
                ], -1)),
                _cache[7] || (_cache[7] = _createElementVNode("div", null, "endpoint_id[]", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("div", null, "subid", -1)),
                (statistic.method === 'getStatisticsBySubids')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", null, "page", -1)),
                      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
                        _createTextVNode("entries_per_page"),
                        _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(100 by default)")
                      ], -1))
                    ], 64))
                  : _createCommentVNode("", true),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mt-2 font-bold" }, "Example:", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("a", {
                    href: `https://api.${_ctx.user.project.host}/api/statistics/publisher/direct/${statistic.method}?api_token=${_ctx.user.api_token}&date_from=${_ctx.dateFrom}&date_to=${_ctx.dateTo}`,
                    target: "_blank"
                  }, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/publisher/direct/" + _toDisplayString(statistic.method) + "?api_token=" + _toDisplayString(_ctx.user.api_token) + "&date_from=" + _toDisplayString(_ctx.dateFrom) + "&date_to=" + _toDisplayString(_ctx.dateTo), 9, _hoisted_5)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_PrimeVueTabPanel, { header: "RTB publishers API" }, {
          default: _withCtx(() => [
            _cache[21] || (_cache[21] = _createElementVNode("h4", null, "Statistics", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statisticsRTBPublisher, (statistic, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("h5", null, _toDisplayString(statistic.title), 1),
                _createElementVNode("code", _hoisted_6, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/publisher/rtb/" + _toDisplayString(statistic.method), 1),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mt-2 font-bold" }, "Available params:", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                  _createTextVNode("api_token"),
                  _createElementVNode("span", { class: "ml-2 text-pink-300" }, "Required")
                ], -1)),
                _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                  _createTextVNode("date_from"),
                  _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
                ], -1)),
                _cache[16] || (_cache[16] = _createElementVNode("div", null, [
                  _createTextVNode("date_to"),
                  _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
                ], -1)),
                _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                  _createTextVNode("date"),
                  _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
                ], -1)),
                _cache[18] || (_cache[18] = _createElementVNode("div", null, "endpoint_id[]", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("div", null, "subid", -1)),
                (statistic.method === 'getStatisticsBySubids')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", null, "page", -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                        _createTextVNode("entries_per_page"),
                        _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(100 by default)")
                      ], -1))
                    ], 64))
                  : _createCommentVNode("", true),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mt-2 font-bold" }, "Example:", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    href: `https://api.${_ctx.user.project.host}/api/statistics/publisher/rtb/${statistic.method}?api_token=${_ctx.user.api_token}&date_from=${_ctx.dateFrom}&date_to=${_ctx.dateTo}`,
                    target: "_blank"
                  }, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/publisher/rtb/" + _toDisplayString(statistic.method) + "?api_token=" + _toDisplayString(_ctx.user.api_token) + "&date_from=" + _toDisplayString(_ctx.dateFrom) + "&date_to=" + _toDisplayString(_ctx.dateTo), 9, _hoisted_8)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_PrimeVueTabPanel, { header: "Advertisers API" }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimeVueMessage, {
              class: "mt-0",
              severity: "warn",
              closable: false
            }, {
              default: _withCtx(() => [
                _cache[22] || (_cache[22] = _createElementVNode("div", null, "This API is deprecated as of 20.07.2026, but don't worry — it will keep working for now. For any new integrations, we'd really encourage you to go with API v3 instead:", -1)),
                _createElementVNode("a", {
                  class: "underline font-bold",
                  style: {"color":"inherit"},
                  href: `https://api.${_ctx.user.project.host}/docs/v3`,
                  target: "_blank"
                }, "https://api." + _toDisplayString(_ctx.user.project.host) + "/docs/v3", 9, _hoisted_9)
              ]),
              _: 1
            }),
            _cache[32] || (_cache[32] = _createElementVNode("h4", null, "Statistics", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statisticsAdvertiser, (statistic, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("h5", null, _toDisplayString(statistic.title), 1),
                _createElementVNode("code", _hoisted_10, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/advertiser/" + _toDisplayString(statistic.method), 1),
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mt-2 font-bold" }, "Available params:", -1)),
                _cache[26] || (_cache[26] = _createElementVNode("div", null, [
                  _createTextVNode("api_token"),
                  _createElementVNode("span", { class: "ml-2 text-pink-300" }, "Required")
                ], -1)),
                _cache[27] || (_cache[27] = _createElementVNode("div", null, [
                  _createTextVNode("date_from"),
                  _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
                ], -1)),
                _cache[28] || (_cache[28] = _createElementVNode("div", null, [
                  _createTextVNode("date_to"),
                  _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
                ], -1)),
                _cache[29] || (_cache[29] = _createElementVNode("div", null, [
                  _createTextVNode("date"),
                  _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
                ], -1)),
                _cache[30] || (_cache[30] = _createElementVNode("div", null, "campaign_id[]", -1)),
                (statistic.method === 'getStatisticsBySubids')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", null, "page", -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("div", null, [
                        _createTextVNode("entries_per_page"),
                        _createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(100 by default)")
                      ], -1))
                    ], 64))
                  : _createCommentVNode("", true),
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "mt-2 font-bold" }, "Example:", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", {
                    href: `https://api.${_ctx.user.project.host}/api/statistics/advertiser/${statistic.method}?api_token=${_ctx.user.api_token}&date_from=${_ctx.dateFrom}&date_to=${_ctx.dateTo}`,
                    target: "_blank"
                  }, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/advertiser/" + _toDisplayString(statistic.method) + "?api_token=" + _toDisplayString(_ctx.user.api_token) + "&date_from=" + _toDisplayString(_ctx.dateFrom) + "&date_to=" + _toDisplayString(_ctx.dateTo), 9, _hoisted_12)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}